<template>
  <v-container fluid :fill-height="loading || (showStart && $vuetify.breakpoint.smAndDown)" class="apply-job py-0">

    <v-progress-linear style="position: fixed; left: 0; right: 0; margin: 0; z-index: 99;"
                       :style="{top: $vuetify.breakpoint.smAndDown ? '54px' : '62px'}" color="primary lighten-2"
                       height="2" v-show="subtleLoading" :indeterminate="true"></v-progress-linear>

    <v-row v-if="preview" no-gutters>
      <v-col cols="12">
        <v-system-bar color="warning">
          <v-row no-gutters>
            <v-col cols="12" class="text-center">
              {{ $t('public_job_ads.this_is_preview') }}
            </v-col>
          </v-row>
        </v-system-bar>
      </v-col>
    </v-row>

    <hb-loading-indicator v-if="loading" align-middle/>

    <v-fade-transition hide-on-leave>
      <v-row v-if="!loading && showStart" style="position: relative;" :class="$vuetify.breakpoint.smAndDown ? 'fill-height' : ''">
        <v-col cols="12" md="8" offset-md="2" xl="6" offset-xl="3" :class="$vuetify.breakpoint.smAndDown ? 'fill-height' : ''">
          <v-card color="secondary" :class="$vuetify.breakpoint.smAndDown ? 'fill-height' : ''">
            <v-container fill-height pa-6>
              <v-row>
                <v-col cols="12" class="py-16">
                  <div style="position: relative;">
                    <div class="headline mb-5">{{ job.name }}</div>
                    <div class="title mb-5 introduction">{{ $t('public_job_ads.apply_guide_text') }}</div>
                    <v-btn color="primary" :block="$vuetify.breakpoint.smAndDown" class="accent-2--text" @click="startAnswering">{{ $t('online_test.start') }}</v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-fade-transition>

    <v-fade-transition hide-on-leave>
      <v-row v-if="!loading && !showStart">
        <v-col cols="12" v-if="questions.length > 0 && !showThanks"  md="10" offset-md="1" xl="8" offset-xl="2" :class="$vuetify.breakpoint.smAndDown ? 'pb-13' : ''">
          <v-card>
              <v-card-text>
                <div class="caption">
                  <v-container pa-0>
                    <v-row no-gutters>
                      <v-col cols="12" class="text-right text-h6">
                        {{job.name}}
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
                <v-progress-linear height="2" color="secondary" :value="currentProgressValue"></v-progress-linear>
              </v-card-text>
              <v-card-text class="black--text">
                  <div>

                      <template v-if="currentQuestionIndex < questions.length">
                        <div class="title">{{ questions[currentQuestionIndex].questionText }}</div>
                        <div v-if="questions[currentQuestionIndex].questionHelpText" class="subtitle-2">
                          {{ questions[currentQuestionIndex].questionHelpText }}
                        </div>

                        <div class="mt-5"></div>

                        <template v-if="questions[currentQuestionIndex].type === 'EXPERIENCE'">
                          <template v-for="value in questions[currentQuestionIndex].values">
                            <v-card class="mb-2 option-card" :key="value.tempId">
                              <v-card-text class="pb-0">
                                <v-combobox :items="industries"
                                            class="mt-1"
                                            v-model="value.industry"
                                            item-text="name"
                                            item-value="code"
                                            :label="$t('experience.industry_select')">
                                  <template v-slot:item="{ item }">
                                    <v-list-item-title>
                                      <span :class="item.level === 1 ? 'font-weight-bold' : ''">
                                        {{ item.level > 1 ? '——'.repeat(item.level - 1) + ' ' : '' }}{{ item.name }}
                                      </span>
                                    </v-list-item-title>
                                  </template>
                                </v-combobox>
                                <v-slider v-model="value.years"
                                          v-if="value.industry"
                                          min="0"
                                          max="6"
                                          hide-details
                                          tick-size="5"
                                          ticks="always"
                                          thumb-color="accent"
                                          always-dirty>
                                </v-slider>
                                <template v-if="value.years === 0">
                                  {{ $t('experience.none') }}
                                </template>
                                <template v-else-if="value.years === 6">
                                  {{ $t('experience.over_x_years', {x: value.years - 1}) }}
                                </template>
                                <template v-else-if="value.industry">
                                  {{ value.years }} {{ $tc('experience.year', value.years === 1 ? 1 : 2) }}
                                </template>
                              </v-card-text>
                              <v-card-actions class="pt-0">
                                <v-spacer />
                                <v-btn small color="red" text @click="removeWorkExperience(value.tempId)">Poista</v-btn>
                              </v-card-actions>
                            </v-card>
                          </template>
                          <v-btn small color="accent" depressed class="primary--text" block @click="addWorkExperience">
                            <v-icon left>add</v-icon>
                            {{ $t('experience.add_experience') }}
                          </v-btn>
                        </template>

                        <template v-if="questions[currentQuestionIndex].type === 'EDUCATION'">
                            <template v-for="option in questions[currentQuestionIndex].options">
                              <v-card class="mb-2 option-card" :key="option.id" :class="option.selected ? 'selected' : ''">
                                <v-checkbox
                                  class="pa-2 ma-0"
                                  v-model="option.selected"
                                  hide-details
                                  :label="option.text"
                                ></v-checkbox>
                                <v-card-text v-if="option.selected && !['peruskoulu', 'lukio'].includes(option.value)">
                                  <v-combobox :items="industries"
                                              class="mt-1"
                                              v-model="option.industries"
                                              item-text="name"
                                              item-value="code"
                                              multiple
                                              hide-details
                                              :label="$t('education.industry_select')">
                                    <template v-slot:item="{ item }">
                                      <v-list-item-title>
                                        <span :class="item.level === 1 ? 'font-weight-bold' : ''">
                                          {{ item.level > 1 ? '——'.repeat(item.level - 1) + ' ' : '' }}{{ item.name }}
                                        </span>
                                      </v-list-item-title>
                                    </template>
                                  </v-combobox>
                                </v-card-text>
                              </v-card>
                            </template>
                        </template>

                        <template v-if="questions[currentQuestionIndex].type === 'LICENSES'">
                          <template v-for="license in questions[currentQuestionIndex].licenses">
                            <v-card class="mb-2 option-card" :key="license.id" :class="license.selected ? 'selected' : ''">
                              <v-checkbox
                                class="pa-2 ma-0"
                                v-model="license.selected"
                                hide-details
                                :label="$te(`licenses.${license.code}`) ? $t(`licenses.${license.code}`) : license.code"
                              ></v-checkbox>
                            </v-card>
                          </template>
                        </template>

                        <template v-if="questions[currentQuestionIndex].type === 'SELECT_MANY'">
                          <v-card class="mb-2 option-card" v-for="answer in questions[currentQuestionIndex].answers" :key="answer.id" :class="answer.selected ? 'selected' : ''">
                            <v-checkbox
                              class="pa-2 ma-0"
                              v-model="answer.selected"
                              hide-details
                              :label="answer.answerText"
                            ></v-checkbox>
                          </v-card>
                        </template>

                        <template v-if="questions[currentQuestionIndex].type === 'SELECT_ONE'">
                          <v-radio-group v-model="questions[currentQuestionIndex].selectedAnswer" hide-details>
                            <v-card class="mb-2 option-card" v-for="answer in questions[currentQuestionIndex].answers" :key="answer.id" :class="questions[currentQuestionIndex].selectedAnswer === answer.id ? 'selected' : ''">
                              <v-radio
                                class="pa-2 ma-0"
                                hide-details
                                :label="answer.answerText"
                                :value="answer.id"
                              ></v-radio>
                            </v-card>
                          </v-radio-group>
                        </template>

                        <template v-if="questions[currentQuestionIndex].type === 'SCALE'">
                          <v-row no-gutters class="pt-5">
                            <v-col cols="6" class="pa-0 ma-0 text-left">{{ $t('online_test.not_at_all') }}</v-col>
                            <v-col cols="6" class="pa-0 ma-0 text-right">{{ $t('online_test.completely') }}</v-col>
                          </v-row>
                          <v-slider
                            v-model="questions[currentQuestionIndex].selectedAnswer"
                            max="5"
                            min="1"
                            track-color="#CFD3E6"
                            track-fill-color="#3CDBC0"
                            tick-size="4"
                            ticks="always"
                          ></v-slider>
                        </template>

                        <template v-if="questions[currentQuestionIndex].type === 'FREE_TEXT'">
                          <v-textarea v-model="questions[currentQuestionIndex].selectedAnswer"
                                      outlined
                                      hide-details
                                      class="rounded"
                                      validate-on-blur />
                        </template>
                      </template>


                    <template v-if="currentQuestionIndex === questions.length && !showThanks">
                      <div class="title mb-5">{{ $t('public_job_ads.fill_your_contact_info') }}</div>
                      <v-form ref="form">
                        <v-row>
                          <v-col cols="12" class="py-1">
                            <v-text-field v-model="firstName"
                                          :rules="[$rules.required]"
                                          :label="$t('public_job_ads.first_name')"
                                          :hint="$t('validation.field_is_required')"
                                          persistent-hint
                                          outlined
                                          class="rounded"
                                          validate-on-blur />
                          </v-col>
                          <v-col cols="12" class="py-1">
                            <v-text-field v-model="lastName"
                                          :rules="[$rules.required]"
                                          :label="$t('public_job_ads.last_name')"
                                          :hint="$t('validation.field_is_required')"
                                          persistent-hint
                                          outlined
                                          class="rounded"
                                          validate-on-blur />
                          </v-col>
                          <v-col cols="12" class="py-1">
                            <v-text-field v-model="phone"
                                          :rules="[$rules.required]"
                                          :label="$t('public_job_ads.phone')"
                                          :hint="$t('validation.field_is_required')"
                                          persistent-hint
                                          outlined
                                          class="rounded"
                                          validate-on-blur />
                          </v-col>
                          <v-col cols="12" class="py-1">
                            <v-text-field v-model="email"
                                          :rules="[$rules.required, $rules.email]"
                                          :label="$t('public_job_ads.email')"
                                          :hint="$t('validation.field_is_required')"
                                          @change="email = email.trim()"
                                          persistent-hint
                                          outlined
                                          class="rounded"
                                          validate-on-blur />
                          </v-col>
                          <v-col cols="12" class="py-1">
                            <v-text-field v-model="address"
                                          v-on:keyup.enter="submitForm"
                                          :rules="[$rules.required]"
                                          :label="$t('public_job_ads.address')"
                                          :hint="$t('validation.field_is_required')"
                                          persistent-hint
                                          outlined
                                          class="rounded"
                                          validate-on-blur />
                          </v-col>
                          <v-col cols="12" class="py-1">
                            <v-text-field v-model="zipcode"
                                          v-on:keyup.enter="submitForm"
                                          :rules="[$rules.required]"
                                          :label="$t('public_job_ads.zipcode')"
                                          :hint="$t('validation.field_is_required')"
                                          persistent-hint
                                          outlined
                                          class="rounded"
                                          validate-on-blur />
                          </v-col>
                          <v-col cols="12" class="py-1">
                            <v-text-field v-model="city"
                                          v-on:keyup.enter="submitForm"
                                          :rules="[$rules.required]"
                                          :label="$t('public_job_ads.city')"
                                          :hint="$t('validation.field_is_required')"
                                          persistent-hint
                                          outlined
                                          class="rounded"
                                          validate-on-blur />
                          </v-col>
                          <v-col cols="12" class="py-1">
                            <v-text-field :value="cvFileName"
                                          prepend-inner-icon="mdi mdi-paperclip"
                                          :label="$t('cv')"
                                          readonly
                                          @click="changeCV"
                                          @click:clear="clearCV"
                                          outlined
                                          class="rounded"
                                          clearable />
                            <input type="file" style="display:none" :multiple="false" ref="cvFileInput" @change="onCVFileChanged">
                          </v-col>
                          <v-col v-for="af in additionalFiles" :key="af.tmpId" cols="12" class="py-1">
                            <v-text-field :value="additionalFileName(af)"
                                          prepend-inner-icon="mdi mdi-paperclip"
                                          :label="$t('file')"
                                          readonly
                                          @click="changeFile(af)"
                                          @click:clear="clearFile(af)"
                                          outlined
                                          class="rounded"
                                          clearable />
                            <input type="file" style="display:none" :multiple="false" :ref="`fileInput${af.tmpId}`" @change="onFileChanged($event, af)" @cancel="onFileCancel(af)">
                          </v-col>
                          <v-col cols="12" class="py-1 mb-10">
                            <v-btn small color="accent" depressed class="primary--text" block @click="addFile">
                              <v-icon left>add</v-icon>
                              {{ $t('public_job_ads.add_other_file') }}
                            </v-btn>
                          </v-col>
                          <v-col cols="12" class="py-1" v-if="!job.openApplication">
                            <v-textarea
                              v-model="reference"
                              :label="$t('public_job_ads.reference')"
                              outlined
                              class="rounded"
                              validate-on-blur />
                          </v-col>
                          <v-col cols="12" class="py-1" v-if="!job.openApplication">
                            <v-textarea
                              v-model="additionalInformation"
                              :label="$t('public_job_ads.additional_information')"
                              outlined
                              class="rounded"
                              validate-on-blur />
                          </v-col>
                        </v-row>
                      </v-form>
                    </template>

                    <v-checkbox v-model="certifyInformation"
                                hide-details
                                :label="$t('public_job_ads.certify_information')"
                                v-if="currentQuestionIndex === questions.length && !showThanks">
                    </v-checkbox>

                    <v-checkbox v-model="termsAccepted" v-if="currentQuestionIndex === questions.length && !showThanks">
                      <template v-slot:label>
                        <div>
                          {{ $t('public_job_ads.terms_and_conditions_1') }}
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <a
                                target="_blank"
                                href="https://hrsata.fi/tietosuojaseloste/rekisteriseloste/"
                                @click.stop
                                v-on="on">
                                {{ $t('public_job_ads.terms_and_conditions_2') }}
                              </a>
                            </template>
                            <span>{{ $t('public_job_ads.terms_and_conditions_hint') }}</span>
                          </v-tooltip>
                          {{ $t('public_job_ads.terms_and_conditions_3') }}
                        </div>
                      </template>
                    </v-checkbox>

                    <template v-if="currentQuestionIndex === questions.length && !showThanks">
                      <div class="title mt-4 mb-5">{{ $t('public_job_ads.where_did_you_find') }}</div>
                      <v-radio-group v-model="whereDidYouFindAnswer" hide-details>
                        <v-card class="mb-2 option-card" v-for="answer in whereDidYouFindOptions" :key="answer.id" :class="whereDidYouFindAnswer === answer.id ? 'selected' : ''">
                          <v-radio
                            class="pa-2 ma-0"
                            hide-details
                            :label="answer.text"
                            :value="answer.id"
                          ></v-radio>
                        </v-card>
                      </v-radio-group>
                      <v-text-field v-model="whereDidYouFindAnswerText"
                                    :style="{visibility: isSomethingElseSelectedForWhereDidYouFind ? 'visible' : 'hidden'}"
                                    :placeholder="whereDidYouFindOptions[whereDidYouFindOptions.length - 1].text"
                                    outlined
                                    class="rounded" />
                    </template>

                    <v-row no-gutters :class="$vuetify.breakpoint.smAndDown ? '' : 'mt-7'">
                      <v-col cols="6" class="pr-1">
                        <v-btn :disabled="previousQuestionIndexes.length < 1"
                               @click="previousQuestion"
                               :block="$vuetify.breakpoint.mdAndUp"
                               :style="$vuetify.breakpoint.smAndDown ? 'width: 43%;' : ''"
                               elevation="0"
                               color="#CFD3E6"
                               :fixed="$vuetify.breakpoint.smAndDown"
                               :bottom="$vuetify.breakpoint.smAndDown"
                               :left="$vuetify.breakpoint.smAndDown">
                          <v-icon left>mdi mdi-arrow-left</v-icon>{{ $t('previous') }}
                        </v-btn>
                      </v-col>
                      <v-col cols="6" class="pl-1">
                        <v-btn @click="nextQuestionClick"
                               :disabled="!currentQuestionAnswered"
                               v-if="currentQuestionIndex < questions.length"
                               :block="$vuetify.breakpoint.mdAndUp"
                               :style="$vuetify.breakpoint.smAndDown ? 'width: 43%;' : ''"
                               elevation="0"
                               class="accent-2--text"
                               color="primary"
                               :fixed="$vuetify.breakpoint.smAndDown"
                               :bottom="$vuetify.breakpoint.smAndDown"
                               :right="$vuetify.breakpoint.smAndDown">
                          {{ $t('next') }}<v-icon right>mdi mdi-arrow-right</v-icon>
                        </v-btn>
                        <v-btn @click="submitJobApplication"
                               :disabled="!termsAccepted || !certifyInformation"
                               v-else
                               :block="$vuetify.breakpoint.mdAndUp"
                               :style="$vuetify.breakpoint.smAndDown ? 'width: 43%;' : ''"
                               :loading="sending"
                               elevation="0"
                               class="accent-2--text"
                               color="primary"
                               :fixed="$vuetify.breakpoint.smAndDown"
                               :bottom="$vuetify.breakpoint.smAndDown"
                               :right="$vuetify.breakpoint.smAndDown">
                          {{ $t('send') }}!
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
              </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-fade-transition>

    <v-fade-transition hide-on-leave>
      <v-row v-if="!loading && !showStart && showThanks">
        <v-col cols="12" md="10" offset-md="1" xl="8" offset-xl="2" :class="$vuetify.breakpoint.smAndDown ? 'pb-13' : ''">
          <v-card>
            <v-card-text class="black--text">
              <v-container fill-height>
                <v-row>
                  <v-col cols="12" class="py-16">
                    <div style="position: relative;">
                      <!-- <v-img :src="$assetImageUrl + 'img/face-4.svg'" width="100" class="face-2"/>-->
                      <div class="headline mb-5">{{ $t('public_job_ads.thanks') }}</div>
                      <div class="title mb-5" style="white-space: pre-line;">
                        {{ $t('public_job_ads.application_send_check_your_email') }}
                      </div>

                      <div>{{ postApplicationData && postApplicationData.postApplicationGuideText ? postApplicationData.postApplicationGuideText : $t('public_job_ads.apply_for_another_job') }}</div>
                      <v-btn color="primary"
                             v-if="postApplicationData && postApplicationData.postApplicationButtonVisible"
                             :small="$vuetify.breakpoint.xsOnly"
                             :block="$vuetify.breakpoint.smAndDown"
                             exact
                             v-bind="postApplicationButtonLink"
                             class="accent-2--text mt-2">
                        {{ postApplicationData && postApplicationData.postApplicationButtonText ? postApplicationData.postApplicationButtonText : $t('public_job_ads.move_back_to_list') }}
                      </v-btn>

                      <div class="mt-5">
                        {{ $t('public_job_ads.best_regards') }},
                        <br />
                        {{ postApplicationData && postApplicationData.name }}
                        <br />
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-fade-transition>

  </v-container>
</template>

<script>
import sharedApi from '@/jobs/api/shared';
import OnlineTestService from '@/jobs/service/onlinetest.service';
import {educationOptions} from '@/config/parameters.js';

export default {
  name: "ApplyJobView",
  props: {
    jobId: {
      type: [String, Number],
      default: -1,
    },
    testView: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      loading: true,
      subtleLoading: false,
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      address: '',
      zipcode: '',
      city: '',
      sending: false,
      showStart: true,
      showThanks: false,
      userCreated: false,
      currentQuestionIndex: -1,
      previousQuestionIndexes: [],
      job: {},
      questions: [],
      termsAccepted: false,
      certifyInformation: false,
      whereDidYouFindAnswer: 0,
      whereDidYouFindAnswerText: '',
      whereDidYouFindOptions: [],
      cv: null,
      additionalFiles: [],
      loadingCV: false,
      loadingFile: false,
      loggedAnswers: [],
      preview: undefined,
      reference: '',
      additionalInformation: '',
      file: {},
      licenses: null,
      industries: [],
      experienceTemplate: {
        years: null, industry: null, employer: '',
      },
      fileCounter: 0,
      postApplicationData: null,
    }
  },
  methods: {
    addWorkExperience() {
      this.questions[this.currentQuestionIndex].values.push(
        Object.assign({tempId: this.questions[this.currentQuestionIndex].values.length}, this.experienceTemplate)
      )
    },
    removeWorkExperience(tempId) {
      const i = this.questions[this.currentQuestionIndex].values.findIndex(v => v.tempId === tempId);
      if (i > -1) {
        this.questions[this.currentQuestionIndex].values.splice(i, 1);
      }
    },
    changeCV() {
      if (!this.loadingCV) {
        this.$refs.cvFileInput.click();
      }
    },
    clearCV() {
      this.file = {};
      this.$refs.cvFileInput.value = null;
    },
    async onCVFileChanged(event) {
      this.loadingCV = true;

      const f = event.target.files[0];
      const asDataUrl = await this.toBase64(f);
      this.file = {
        file: f,
        dataUrl: asDataUrl,
        name: f.name,
        type: f.type,
        filename: f.name,
        fileDescription: '',
        size: f.size,
      };
      event.target.value = '';

      this.loadingCV = false;
    },
    async onFileChanged(event, af) {
      console.log('onFileChanged', event, af);
      this.loadingFile = true;

      const f = event.target.files[0];
      const asDataUrl = await this.toBase64(f);
      const file = this.additionalFiles.find(f => f.tmpId === af.tmpId);
      Object.assign(file, {
        tmpId: af.tmpId,
        file: f,
        dataUrl: asDataUrl,
        name: f.name,
        type: f.type,
        filename: f.name,
        fileDescription: '',
        size: f.size,
      });
      this.additionalFiles = [ ...this.additionalFiles ];
      event.target.value = '';

      this.loadingFile = false;
    },
    async onFileCancel(af) {
      console.log('onFileCancel', af);
      if (!af.file) {
        this.additionalFiles = this.additionalFiles.filter(f => f.tmpId !== af.tmpId);
      }
    },
    addFile() {
      const tmpId = ++this.fileCounter;
      this.additionalFiles.push({
        tmpId,
      });
      this.$nextTick(() => {
        this.$refs[`fileInput${tmpId}`][0].click();
      });
    },
    changeFile(af) {
      if (!this.loadingFile) {
        this.$refs[`fileInput${af.tmpId}`][0].click();
      }
    },
    clearFile(af) {
      this.additionalFiles = this.additionalFiles.filter(f => f.tmpId !== af.tmpId);
      this.$refs[`fileInput${af.tmpId}`][0] = null;
    },
    async submitJobApplication() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (this.preview) {
        this.$showWarningNotification(this.$t('public_job_ads.preview_not_sent'));
        return;
      }
      if (this.job.state === 1) sharedApi.logJobAdSubmit(this.jobId);
      this.$sendAnalyticsEvent('JobAd', 'submit');
      this.sending = true;
      try {
        const whereId = Number(this.whereDidYouFindAnswer);
        let whereText = '';
        if (whereId) {
          const selectedWhereDidYouFindText = this.whereDidYouFindOptions[whereId - 1].text;
          if (this.isSomethingElseSelectedForWhereDidYouFind) { // Joku muu -valinta
            whereText = `${selectedWhereDidYouFindText}: ${this.whereDidYouFindAnswerText}`;
          } else {
            whereText = selectedWhereDidYouFindText;
          }
        }

        const licenses = []
        this.questions.filter(q => q.type === 'LICENSES').forEach(lq => lq.licenses.forEach(l => {
          if (l.selected) {
            licenses.push(l);
          }
        }));

        const education = [];
        if (this.job.askEducation) {
          const educationQuestion = this.questions.find(q => q.type === 'EDUCATION');
          if (educationQuestion) {
            educationQuestion.options.forEach(o => {
              if (o.selected) {
                if (o.industries && o.industries.length > 0) {
                  o.industries.forEach(industry => {
                    education.push({educationLevel: o.value, industryCode: industry.code});
                  });
                } else {
                  education.push({educationLevel: o.value, industryCode: null});
                }
              }
            });
          }
        }

        const experience = [];
        if (this.job.askExperience) {
          const experienceQuestion = this.questions.find(q => q.type === 'EXPERIENCE');
          if (experienceQuestion) {
            experienceQuestion.values.forEach(v => {
              if (v.industry && v.industry.code) {
                experience.push({years: v.years, industryCode: v.industry.code});
              }
            });
          }
        }

        const response = await sharedApi.applyForJob(this.job.id, {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          phone: this.phone,
          address: this.address,
          zipcode: this.zipcode,
          city: this.city,
          whereText,
          reference: this.reference,
          additionalInformation: this.additionalInformation,
          experience,
          education,
          licenses,
        });

        const handleUploadProgress = (progressEvent) => {
          // TODO: tää näkyviin ehkä johki tai joku loading pylpyrä
          this.uploadPercentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          console.log('uploadPercentCompleted', this.uploadPercentCompleted);
        };

        if (this.file.file) {
          await sharedApi.uploadCv(response.applicantId, response.applicationId, this.file, handleUploadProgress);
        }

        for (const additionalFile of this.additionalFiles) {
          if (additionalFile.file) {
            await sharedApi.uploadAdditionalFile(response.applicantId, response.applicationId, additionalFile, handleUploadProgress);
          }
        }

        this.showThanks = true;
        this.userCreated = response.created;
      } catch (err) {
        this.$handleApiError(err);
      }
      this.sending = false;
    },
    startAnswering() {
      this.showStart = false;
      if (this.job.state === 1 && !this.preview) {
        sharedApi.logJobAdRead(this.jobId);
        this.$sendAnalyticsEvent('JobAd', 'open');
      }
    },
    async reloadData() {
      this.loading = true;
      try {
        const whereDidYouFindOptions = Object.entries({
          '1': this.$t('public_job_ads.source.te'),
          '2': this.$t('public_job_ads.source.website'),
          '3': this.$t('public_job_ads.source.facebook'),
          '4': this.$t('public_job_ads.source.ig'),
          '5': this.$t('public_job_ads.source.linkedin'),
          '6': this.$t('public_job_ads.source.job_portal'),
          '7': this.$t('public_job_ads.source.job_portal_some'),
          '8': this.$t('public_job_ads.source.print'),
          '9': this.$t('public_job_ads.source.newsletter'),
          '10': this.$t('public_job_ads.source.something_else'),
        })
        .sort((a, b) => a[0] - b[0])
        .map(a => ({ id: a[0], text: a[1] }));
        this.whereDidYouFindOptions = whereDidYouFindOptions;

        const job = await sharedApi.getJobAd(this.jobId);

        const questions = job.questions;
        const answers = OnlineTestService.getAnswers();
        // set previous answers
        questions.forEach(q => {
          const previousAnswer = answers[q.id];
          if (previousAnswer) {
            if (q.type === 'SCALE') {
              q.selectedAnswer = q.answers.findIndex(a => a.id === previousAnswer[0]) + 1;
            } else if (q.type === 'SELECT_MANY') {
              q.answers.forEach(a => a.selected = previousAnswer.includes(a.id));
            } else if (q.type === 'SELECT_ONE') {
              q.selectedAnswer = previousAnswer[0];
            }
          }
        });

        this.industries = await sharedApi.getIndustries();
        this.licenses = await sharedApi.getLicenses();

        if (job.askExperience) {
          questions.unshift({
            type: 'EXPERIENCE',
            values: [Object.assign({tempId: 0}, this.experienceTemplate)],
            questionText: this.$t('public_job_ads.work_experience'),
            questionHelpText: this.$t('experience.help_text'),
          });
        }

        if (job.askEducation) {
          questions.unshift({
            type: 'EDUCATION',
            selectedAnswer: null,
            options: educationOptions,
            questionText: this.$t('public_job_ads.education'),
            questionHelpText: this.$t('education.help_text'),
          });
        }

        if (job.askCardsAndPermits) {
          const jobLicenses = job.licenses.filter(l => l.category === 'LICENSE');
          const jobDrivingLicenses = job.licenses.filter(l => l.category === 'DRIVING');
          const allLicenses = this.licenses.filter(l => {
            if (l.category === 'LICENSE') {
              if (jobLicenses.findIndex(jl => jl.code === l.code)) {
                l.requiredInJob = true;
              }
              return l;
            }
          });
          const allDrivingLicenses = this.licenses.filter(l => {
            if (l.category === 'DRIVING') {
              if (jobDrivingLicenses.findIndex(jl => jl.code === l.code)) {
                l.requiredInJob = true;
              }
              return l;
            }
          });

          if (allLicenses.length > 0) {
            questions.push({
              type: 'LICENSES',
              licenses: allLicenses,
              questionText: this.$t('public_job_ads.select_licenses'),
              questionHelpText: this.$t('public_job_ads.select_licenses_help'),
            });
          }
          if (allDrivingLicenses.length > 0) {
            questions.push({
              type: 'LICENSES',
              licenses: allDrivingLicenses,
              questionText: this.$t('public_job_ads.select_driving_licenses'),
              questionHelpText: this.$t('public_job_ads.select_driving_licenses_help'),
            });
          }
        }

        this.questions = questions;
        this.job = job;
        await this.nextQuestion();
      } catch (err) {
        this.$handleApiError(err);
      }
      this.loading = false;
    },
    goToOpenJobs() {
      const answers = {};
      this.questions.forEach(q => {
        if (q.type === 'SCALE' && q.selectedAnswer) {
          const a = q.answers[q.selectedAnswer - 1];
          if (a) {
            answers[q.id] = [a.id];
          }
        } else if (q.type === 'SELECT_MANY') {
          answers[q.id] = q.answers.filter(a => a.selected).map(a => a.id);
        } else if (q.type === 'SELECT_ONE' && q.selectedAnswer) {
          answers[q.id] = [q.selectedAnswer];
        }
      });
      OnlineTestService.addAnswers(answers);
      this.$router.push({ name: 'jobs', params: { testView: '1' } });
    },
    updateAnswers() {
      const answers = {};
      const textAnswers = {};
      this.questions.forEach(q => {
        if (q.type === 'SCALE' && q.selectedAnswer) {
          const a = q.answers[q.selectedAnswer - 1];
          if (a) {
            answers[q.id] = [a.id];
          }
        } else if (q.type === 'SELECT_MANY') {
          const qa = q.answers.filter(a => a.selected).map(a => a.id);
          if (qa.length > 0) {
            answers[q.id] = qa;
          }
        } else if (q.type === 'SELECT_ONE' && q.selectedAnswer) {
          answers[q.id] = [q.selectedAnswer];
        } else if (q.type === 'FREE_TEXT') {
          textAnswers[q.id] = q.selectedAnswer;
        }
      });
      return this.preview ? answers : OnlineTestService.addAnswers(answers, textAnswers);
    },
    getAnswerTags() {
      const tags = [];
      this.questions.forEach(q => {
        if (q.type === 'SCALE' && q.selectedAnswer) {
          const a = q.answers[q.selectedAnswer - 1];
          if (a) {
            tags.push.apply(tags, a.tags);
          }
        } else if (q.type === 'SELECT_MANY') {
          q.answers.forEach(a => {
            if (a.selected) {
              tags.push.apply(tags, a.tags);
            }
          });
        } else if (q.type === 'SELECT_ONE' && q.selectedAnswer) {
          const a = q.answers.find(a => a.id === q.selectedAnswer);
          tags.push.apply(tags, a.tags);
        }
      });
      return tags;
    },
    async nextQuestionClick() {
      try {
        if (this.currentQuestionIndex >= 0 && this.currentQuestionIndex < this.questions.length) {
          if (!['LICENSES', 'EXPERIENCE', 'EDUCATION'].includes(this.questions[this.currentQuestionIndex].type)) {
            const qid = this.questions[this.currentQuestionIndex].id;
            if (!this.loggedAnswers.includes(this.jobId + '_' + qid)) {
              if (!this.preview) {
                await sharedApi.logJobAdNextQuestion(this.jobId, qid);
              }
              this.loggedAnswers.push(this.jobId + '_' + qid);
            }
          }
        }
        await this.nextQuestion();
      } catch (error) {
        this.$handleApiError(error);
      }
    },
    async nextQuestion() {
      if (this.currentQuestionIndex >= 0) {
        this.previousQuestionIndexes.push(this.currentQuestionIndex);
      }
      try {
        this.updateAnswers();
        const answerTags = this.getAnswerTags();
        let skip = false;
        do {
          this.currentQuestionIndex++;
          if (this.currentQuestionIndex >= 0 && this.currentQuestionIndex < this.questions.length) {
            const next = this.questions[this.currentQuestionIndex];
            if (!['LICENSES', 'EXPERIENCE', 'EDUCATION'].includes(next.type)) {
              // skip if not all required tags are found, or some exclusive tags found
              skip = !next.requiredTags.map(t => t.description).every(t => answerTags.includes(t)) ||
                next.exclusiveTags.map(t => t.description).some(t => answerTags.includes(t));
            }
          } else {
            skip = false;
          }
        } while (skip);
      } catch (error) {
        this.$handleApiError(error);
      }
    },
    previousQuestion() {
      this.currentQuestionIndex = this.previousQuestionIndexes.pop();
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    additionalFileName(af) {
      return this.loadingFile ? this.$t('loading_file') : af?.name;
    },
    async reloadPostApplicationData() {
      try {
        this.postApplicationData = await sharedApi.getPostApplicationData();
      } catch (e) {
        this.$handleApiError(e);
      }
    }
  },
  computed: {
    postApplicationButtonLink() {
      return this.postApplicationData.postApplicationButtonRedirectUrl
        ? { href: this.postApplicationData.postApplicationButtonRedirectUrl } // External Link
        : { to: {name: 'jobs'} }; // Internal Vue Router Link
    },
    isSomethingElseSelectedForWhereDidYouFind() {
      const whereId = this.whereDidYouFindAnswer;
      const other = this.whereDidYouFindOptions[this.whereDidYouFindOptions.length - 1];
      if (whereId && whereId === other.id) {
        return true;
      }

      return false;
    },
    currentQuestionAnswered() {
      const q = this.questions[this.currentQuestionIndex];
      if (['FREE_TEXT', 'LICENSES', 'EXPERIENCE', 'EDUCATION'].includes(q.type)) {
        return true;
      } else if (q.type === 'SELECT_MANY') {
        return q.answers.some(a => a.selected);
      } else {
        return !!q.selectedAnswer;
      }
    },
    currentProgressValue() {
      return (this.currentQuestionIndex / this.questions.length) * 100;
    },
    cvFileName() {
      return this.loadingCV ? this.$t('loading_file') : this.file?.name;
    },
  },
  async mounted() {
    this.preview = this.$route.query.preview;
    await this.reloadPostApplicationData();
    if (this.preview === 'thanks') {
      this.showThanks = true;
      this.showStart = false;
      this.loading = false;
    } else {
      await this.reloadData();
    }
    this.$vuetify.goTo(0, { duration: 0 });
  }
}
</script>

<style lang="scss" scoped>
.option-card {
  border: 2px solid #CFD3E6;

  &.selected {
    border-color: #3CDBC0;
  }
}
.face {
  position: absolute;
  top: -60px;
  right: 20px;
}
.face-2 {
  position: absolute;
  top: -120px;
  right: 20px;
}

@media only screen and (min-width: 960px) {
  .introduction {
    padding-right: 100px;
  }
}

@media only screen and (min-width: 1200px) {
  .introduction {
    padding-right: 200px;
  }
  .face {
    top: -30px;
    right: 60px;
  }
  .face-2 {
    top: -120px;
    right: 60px;
  }
}
</style>
